export enum MarketIntelligencePages {
  locationsTable = 'locationsTable',
  competitorsByLocations = 'competitorsByLocations',
}
